import { render, staticRenderFns } from "./setPhonePage.vue?vue&type=template&id=131e8f0f&scoped=true&"
import script from "./setPhonePage.vue?vue&type=script&lang=js&"
export * from "./setPhonePage.vue?vue&type=script&lang=js&"
import style0 from "./setPhonePage.vue?vue&type=style&index=0&id=131e8f0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131e8f0f",
  null
  
)

export default component.exports